import { api, apiFetch } from './client';

// ── Types ──

export interface ImageBlocklistEntry {
  id: number;
  pattern: string;
  pattern_type: 'domain' | 'path' | 'filename' | 'regex';
  category: 'tracking' | 'platform_ui' | 'icon' | 'decoration' | 'logo' | 'other';
  is_active: boolean;
  hit_count: number;
  notes?: string;
  created_at: string;
  updated_at: string;
}

export interface TestUrlResult {
  url: string;
  blocked: boolean;
  matched_pattern?: string;
  matched_id?: number;
  category?: string;
}

export interface ApplyAllResult {
  total_images: number;
  blocked: number;
  cleaned: number;
  errors: number;
}

// ── API ──

export const imageBlocklistApi = {
  list: (activeOnly?: boolean) =>
    api.get<ImageBlocklistEntry[]>('/image-blocklist' + (activeOnly !== undefined ? `?active=${activeOnly}` : '')),

  getById: (id: number) =>
    api.get<ImageBlocklistEntry>(`/image-blocklist/${id}`),

  create: (data: { pattern: string; pattern_type: string; category: string; notes?: string }) =>
    api.post<ImageBlocklistEntry>('/image-blocklist', data),

  update: (id: number, data: Partial<{ pattern: string; pattern_type: string; category: string; is_active: boolean; notes: string }>) =>
    apiFetch<ImageBlocklistEntry>(`/image-blocklist/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    }),

  delete: (id: number) =>
    api.delete<{ deleted: boolean }>(`/image-blocklist/${id}`),

  testUrl: (url: string) =>
    api.post<TestUrlResult>('/image-blocklist/test', { url }),

  applyAll: () =>
    api.post<ApplyAllResult>('/image-blocklist/apply-all'),

  applyTask: (taskId: string) =>
    api.post<{ task_id: string; blocked: number; cleaned: number }>(`/image-blocklist/apply/${taskId}`),
};
